import { supabase } from "../../../supabaseClient.js";

/**
 * Crea el inventario inicial para un período dado
 * @param {number} periodoId - ID del período
 * @returns {Promise<{success: boolean, data?: any, error?: string}>}
 */
export const rpc_CrearInventarioInicial = async (periodoId) => {
  if (!periodoId) {
    console.warn(
      "[rpc_CrearInventarioInicial.repository] periodoId es requerido",
    );
    return { success: false, error: "El periodoId es requerido" };
  }

  try {
    console.debug(
      "[rpc_CrearInventarioInicial.repository] Llamando RPC crear_inventario_inicial:",
      { periodoId },
    );

    const { data, error } = await supabase.rpc("crear_inventario_inicial", {
      p_periodo_id: periodoId,
    });

    if (error) {
      console.error(
        "[crearVistaInventarioInicial.repository] Error RPC crear_inventario_inicial:",
        {
          periodoId,
          message: error.message,
          details: error.details,
        },
      );
      return { success: false, error: error.message };
    }

    console.info(
      "[infraestructure.crearVistaInventarioInicial.repository] Inventario inicial creado correctamente:",
      { periodoId, data },
    );
    return { success: true, data };
  } catch (unexpectedError) {
    console.error(
      "[services.procesosInventarioInicial.repository ] Error inesperado al crear inventario inicial:",
      {
        periodoId,
        error: unexpectedError?.message || unexpectedError,
      },
    );
    return {
      success: false,
      error: unexpectedError?.message || "Error inesperado",
    };
  }
};

// vista
export async function obtenerInventarioInicial() {
  try {
    const { data, error } = await supabase.from("inventario_inicial_periodo")
      .select(`
    id_inventario,
    periodo_id,
    id_producto,
    stock_apertura,
    bloqueado,
    created_at,
    created_by,
    productos_precio!fk_inventario_producto (
      nombre
    )
  `);

    if (error) {
      console.error(
        "services.procesosInventarioInicial.repository  Error:",
        error.message,
      );
      return { success: false, data: [], error: error.message };
    }

    return { success: true, data };
  } catch (error) {
    console.error(
      "[services.procesosInventarioInicial.repository] Error inesperado:",
      error,
    );
    return { success: false, data: [], error: error.message };
  }
}

export async function actualizarCantidadInventario({ idInventario, cantidad }) {
  const { data, error } = await supabase
    .from("inventario_inicial_periodo")
    .update({
      stock_apertura: cantidad,
      bloqueado: true
    })
    .eq("id_inventario", idInventario)
    .eq("bloqueado", false)
    .select(); 
  if (error) {
    console.error(
      "[procesosInventarioInicial.repository] Error actualizando cantidad:",
      error.message
    );
    return { success: false, error: error.message };
  }

  return {
    success: true,
    actualizado: data?.[0] ?? null
  };
}